module.exports = __webpack_public_path__ + "media/images/admin/icons/facebook-54b6ed1796ae51e7991a86b99ceb8334.svg";